<template>
    <div class="b-white rounded shadow-sm p-3 mb-3">
        <div class="profile d-flex align-items-center">
            <i class="fas fa-star font-yellow mx-3"></i>
            <img :src="creatorImage" alt="" height="30" width="30" class="rounded-circle">
            <h5 class="ml-3 font-gray-dark">{{match.user.name}} {{match.user.lname ? match.user.lname : ''}}</h5>
        </div>
        <hr>
        <router-link :to="'/job/' + job_id + '/recomendation/cv?candidate_id=' + match.user.id + '&job_id=' + job_id" class="btn b-yellow shadow-sm" target="_blank">
            <i class="fas fa-eye"></i>
            Ver Información
        </router-link>
    </div>
</template>
<script>
export default {
    props:{
        job_id: Number,
        match: Object
    },
    data() {
        return {
            defaultImage: require('@/assets/profile/user_empty.png')
        }
    },
    computed: {
        creatorImage(){
            return this.match.user.avatar && this.match.user.avatar != 'null' ? this.match.user.avatar : this.defaultImage
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/candidates_gold/components/CandidateElement.vue